import { SelectLoadingIndicator } from "../../shared/UxbiSpinner";
import { AsyncPaginate } from "react-select-async-paginate";
import { useCallback } from "react";

export default function AsyncSelectERP({
  value,
  onChange,
  loadOptionsApi,
  additionalFilters = [],
  placeholder = "Seleccionar",
  isDisabled = false,
  onInputChange,
}) {
  const loadOptions = useCallback(
    async (search, loadedOptions, { page }) => {
      const response = await loadOptionsApi({
        search,
        page,
        limit: 15,
        extraFilters: additionalFilters,
      });

      return {
        options: response.data.map((item) => ({
          value: item.id,
          label:
            item.nombre ??
            item.descripcion ??
            "F-" + item.folio + " / $" + item.importe,
          data: [item],
        })),
        hasMore: page * 15 < response.total,
        additional: {
          page: page + 1,
        },
      };
    },
    [additionalFilters, loadOptionsApi],
  );

  return (
    <AsyncPaginate
      components={{ LoadingIndicator: SelectLoadingIndicator }}
      loadingMessage={() => (
        <span className="select-loading-message">
          <SelectLoadingIndicator /> Cargando…
        </span>
      )}
      noOptionsMessage={() => "Sin opciones disponibles"}
      value={value}
      loadOptions={loadOptions}
      onChange={onChange}
      onInputChange={onInputChange}
      additional={{ page: 1 }}
      placeholder={placeholder}
      debounceTimeout={300}
      cacheUniqs={[JSON.stringify(additionalFilters)]}
      isDisabled={isDisabled}
      getOptionValue={(option) => option.value}
      getOptionLabel={(option) => option.label}
    />
  );
}
